import { application } from "./application"

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import BulkDeleteController from "./bulk_delete_controller"
application.register("bulk-delete", BulkDeleteController)

import useful_materials_form_controller from "./useful_materials_form_controller"
application.register("useful-materials-form", useful_materials_form_controller)

import confirm_controller from "./confirm_controller"
application.register("confirm", confirm_controller)
